import { render, staticRenderFns } from "./KurehaQuizTest.vue?vue&type=template&id=5677a5bc&scoped=true&"
import script from "./KurehaQuizTest.vue?vue&type=script&lang=js&"
export * from "./KurehaQuizTest.vue?vue&type=script&lang=js&"
import style0 from "./KurehaQuizTest.vue?vue&type=style&index=0&id=5677a5bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5677a5bc",
  null
  
)

export default component.exports